export default __webpack_public_path__ + "static/media/gallery.b55a8486.svg";